export const SourceType = {
    PROJECT: "Project",
    SITE: "Site",
    TRAVEL_REQUEST: "Travel Request",
    TICKET: "Ticket",
    TASKS: "Task",
} as const;

export type SourceType = (typeof SourceType)[keyof typeof SourceType];
